import { ChangeDetectorRef, Component, forwardRef, Inject } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform, Events, ToastController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';
import { Detail } from "../detail/detail";

@Component({
  selector: 'page-message',
  templateUrl: 'message.html',
})

export class MessagePage {
  title: any;
  contentTitle: string = "";
  contentText: string = "";
  messageTitle: string = "";
  messageText: string = "";
  messageImg: string = "";
  data: any;
  moreItemsAvailable: boolean = false;
  loadMoreURL: string = "";
  loadMoreParams: string = "";
  searchword: string = "";
  showSpinner: boolean = false;
  beforeSearchData: any;
  selectedItems: any = [];
  actionForSelectedItems: any;
  actionButtonNameForSelectedItems = "";
  showPrevBtn: boolean = false;
  showNextBtn: boolean = false;
  hideNextBtn: boolean = false;
  goRoot: boolean = false;
  messageIcon: any = false;

  scan_url: string = "";
  scan_params: string = "";
  finish_url: string = "";
  finish_params: string = "";
  finish_viewTypeAction: string = "";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public platform: Platform,
    public events: Events,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public ebsWebserviceGlobals: EbsWebServiceGlobals,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private cdRef: ChangeDetectorRef) {

    //events.publish("reloadMenu");

    if (typeof this.navParams.get("searchresult") != "undefined" && this.navParams.get("searchresult") != null) {
      this.data = this.navParams.get("searchresult");
      this.beforeSearchData = this.data;
      this._ebsWebService.setBrowserTabTitle(this.data.MainTitle);
      this.title = this.data.Caption;
    } else {
      if (typeof this.navParams.get('actionURL') != "undefined") {
        let loading = this.loadingCtrl.create({
          content: 'Bitte warten...'
        });
        loading.present();
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));

        this._ebsWebService.postData(navParams.get('actionURL'), postPayloadObject).subscribe(res => {
          if (typeof res != "undefined" && res != null) {

            this.getActions(res.ListItemAction);

            if (res.ViewType == "Detail") {
              loading.dismiss();
              this.navCtrl.push(Detail, {
                title: res.ListItemNavigation[0].ActionCaption,
                actionURL: res.ListItemNavigation[0].Action,
                postParams: res.ListItemNavigation[0].PostParameters
              });
            } else {
              this.data = res;
              this.beforeSearchData = this.data;

              if (res.Dynamic != null && typeof res.Dynamic.CustomMainTitle != "undefined" && res.Dynamic.CustomMainTitle != null) {
                this.title = res.Dynamic.CustomMainTitle;
              } else {
                this.title = res.MainTitle;
              }

              if (res.Dynamic != null) {
                if (typeof res.Dynamic.ContentTitle != "undefined" && res.Dynamic.ContentTitle != null) {
                  this.contentTitle = res.Dynamic.ContentTitle;
                }

                if (typeof res.Dynamic.ContentText != "undefined" && res.Dynamic.ContentText != null) {
                  this.contentText = res.Dynamic.ContentText;
                }

                if (typeof res.Dynamic.MessageTitle != "undefined" && res.Dynamic.MessageTitle != null) {
                  this.messageTitle = res.Dynamic.MessageTitle;
                }

                if (typeof res.Dynamic.MessageText != "undefined" && res.Dynamic.MessageText != null) {
                  this.messageText = res.Dynamic.MessageText;
                }

                if (typeof res.Dynamic.CustomIcon != "undefined" && res.Dynamic.CustomIcon != null) {
                  this.messageIcon = true;
                  this.messageImg = res.Dynamic.CustomIcon.toLowerCase();
                }

                if (res.Dynamic.HideNextBtn == "True" && res.Dynamic.HideNextBtn != null) {
                  this.hideNextBtn = true;
                }

                if (res.Dynamic.PrevBtn == "True" && res.Dynamic.PrevBtn != null) {
                  this.showPrevBtn = true;
                }

                if (res.Dynamic.AltFinishBtn == "True" && res.Dynamic.AltFinishBtn != null) {
                  this.goRoot = true;
                }
              }

              console.log("message res", res);

              this._ebsWebService.setBrowserTabTitle(res.MainTitle);
              this.cdRef.detectChanges();
              loading.dismiss();
            }
          }
        }, err => {
          loading.dismiss();
          navCtrl.pop();
          this.errorToast();
        });

      }
    }
  }

  getActions(actions) {
    actions.forEach(action => {
      if (action != null) {
        if (action.ActionName == "View") {
          this.scan_url = action.ActionUrl;
          this.scan_params = action.PostParameters;
        }
        if (action.ActionName == "Finish") {
          this.showNextBtn = true;
          this.finish_url = action.ActionUrl;
          this.finish_params = action.PostParameters;
          this.finish_viewTypeAction = action.ViewTypeAction;
        }
      }
    })
  }

  finish() {
    let item = { ActionUrl: this.finish_url, PostParameters: this.finish_params, title: "", ViewTypeAction: this.finish_viewTypeAction };
    console.log(item);
    this.openPage(item);
  }

  openPage(item) {
    if (typeof item.ActionUrl != "undefined" && item.ActionUrl != "" && item.ActionUrl != null) {
      if (this.goRoot == true) {
        item.ActionType = "SetRoot";
      }

      let navParams = { title: item.DisplayName, actionURL: item.ActionUrl, postParams: item.PostParameters };
      console.log(navParams);
      this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
    } else {
      console.log("return");
      return;
    }
  }

  errorToast() {
    let toast = this.toastCtrl.create({
      message: "Fehler beim Laden der Daten",
      duration: 3000,
      position: "bottom"
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/message/message.ts